import React from "react";
import CardContainer from "components/card/CardContainer";

const CourseCard = ({
  images,
  title,
  lessons,
  quiz,
  writer,
  subject,
  onClick,
}) => {
  return (
    <CardContainer
      title={title}
      subject={subject || "Ընդհանուր"}
      image={images.poster}
      onClick={onClick}
      content={
        <div className="flex flex-col gap-2 p-4 w-full text-black">
          <span className="text-[14px] font-[500] line-clamp-2">{title}</span>
          <span className="text-[16px] font-[500]">
            Դասերի քանակ՝ {lessons.length || 0}
          </span>
          <span
            className={`text-[16px] font-[500] ${!!quiz?.questions?.length ? "text-black" : "text-gray-400"}`}
          >
            Հարցում
          </span>
          {writer && (
            <span className="text-[16px] font-[500]">
              Հեղինակ՝ {writer || ""}
            </span>
          )}
        </div>
      }
    />
  );
};

export default CourseCard;
